import React from 'react'
import moment from 'moment'
import Datetime from 'react-datetime'
import {Calendar} from 'jbc-front/components/icons'
import {InputWithIcon} from 'jbc-front/components/presenters/form/InputWithIcon'

type DateFieldProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  inputProps?: any
  value: moment.Moment | string
  onChange: (value: moment.Moment | string) => void
}

type DatetimepickerProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderInput?: (props: any, openCalendar: () => void) => JSX.Element
  value: string | moment.Moment
  onChange: (value: string | moment.Moment) => void
  timeFormat: boolean
}

export const DateField: React.FC<DateFieldProps> = ({inputProps, value, onChange}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderInput = (props: any, openCalendar: () => void) => {
    return (
      <div>
        <InputWithIcon onIconClick={openCalendar} {...props}>
          <Calendar />
        </InputWithIcon>
      </div>
    )
  }

  const datetimeProps: DatetimepickerProps = {
    renderInput: renderInput,
    value: value,
    onChange: (value) => onChange(value),
    timeFormat: false,
  }

  return <Datetime {...datetimeProps} inputProps={{...inputProps}} />
}
